import { render, staticRenderFns } from "./ClientProfileNotifications.vue?vue&type=template&id=e9d95f7a&scoped=true&"
import script from "./ClientProfileNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientProfileNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d95f7a",
  null
  
)

export default component.exports